var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.528 1.843l20.538 10.27L1.528 22.382V1.843z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M24.708.5h1v22.775h-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextButton);
export default __webpack_public_path__ + "static/media/icon-next-button.c138db05.svg";
export { ForwardRef as ReactComponent };